import Api from '../api';
import L from "leaflet";
import "leaflet-control-geocoder";

export default ({
    search: function (value, type) {
        return Api
            .clearParams()
            .addParam('search', value)
            .addParam('by', type)
            .get('geocodes');
    },
    searchByZipcodeAndCity: function (zipcode, city) {
        return Api
            .clearParams()
            .addParam('zipcode', zipcode)
            .addParam('city', city)
            .get('geocodes');
    },
    leafletGeo: function (search) {
        let promise = new Promise((resolve, reject) => {
            if (!search) {
                reject();
            }
            let leafletGeocoder = new L.Control.Geocoder.Nominatim();
            leafletGeocoder.geocode(search, function (results) {
                if (results && results.length > 0) {
                    resolve(results[0]);
                }
                reject(results);
            });
        });
        return promise;
    },
    /**
     * Resolve a free-form address string to coordinates via the backend
     * `/geocode` endpoint. The backend tries Google first, falls back to
     * Nominatim and caches every result, so repeated lookups of the same
     * address do not hit an external provider again.
     *
     * @param {string} address
     * @returns {Promise<{lat: number, lng: number, provider: string}>}
     */
    geocodeAddress: function (address) {
        return Api
            .clearParams()
            .post('geocode', { address: address })
            .then(response => response.data.data);
    }
})